const skipToContent = document.querySelector('.skip-to-content');
if (skipToContent) {
	skipToContent.addEventListener('click', () => {
		const target = document.getElementById('main-content');
		if (target) {
			target.focus();
		}
	});
}
